// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wwPc2","image":"Header_image__3l9_B","name":"Header_name__30GJQ","info":"Header_info__1S5dQ","infoRow":"Header_infoRow__22wKS"};